
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}},_vm.$listeners),[_c('path',{attrs:{"d":"M12,8a2,2,0,1,0,2,2,2,2,0,0,0-2-2"}}),_vm._v(" "),_c('path',{attrs:{"d":"M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0m.714,18.717C12.477,19.429,12.305,20,12,20s-.477-.571-.714-1.283C10.645,16.792,7,12.808,7,10a5,5,0,0,1,10,0c0,2.808-3.645,6.792-4.286,8.717"}})])}
var staticRenderFns = []

    export default {
      render: render,
    }
  